// extracted by mini-css-extract-plugin
export default {"card-verification-container":"card-verification-container--c3L3s","cardVerificationContainer":"card-verification-container--c3L3s"};